import MuiAutocomplete from '@mui/material/Autocomplete';
import { styled } from './styled';

export const Autocomplete = styled(MuiAutocomplete)({
  '&.MuiAutocomplete-hasPopupIcon': {
    '.MuiInputBase-inputAdornedEnd': {
      paddingRight: '24px !important',
    },
  },
  '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon': {
    '.MuiInputBase-inputAdornedEnd': {
      paddingRight: '48px !important',
    },
  },
});
